import { adminApiClient as apiClient } from '../utils/apiClient';

// API service for Client data
export const clientApi = {
  // Get all moderators (GET /moderators/)
  getClients: async (signal = null) => {
    try {
      const config = signal ? { signal } : {};
      const response = await apiClient.get(`/moderators/`, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  },

  // Get paginated moderators (GET /moderators/paginated)
  getClientsPaginated: async ({ skip = 0, limit = 8, search = '', signal = null } = {}) => {
    try {
      const params = { skip, limit };
      const trimmedSearch = typeof search === 'string' ? search.trim() : '';
      if (trimmedSearch) {
        params.search = trimmedSearch;
      }
      const config = signal ? { params, signal } : { params };
      const response = await apiClient.get('/moderators/paginated', config);
      return response.data;
    } catch (error) {
      console.error('Error fetching paginated clients:', error);
      throw error;
    }
  },

  // Get single client by ID
  getClientById: async (id) => {
    try {
      const response = await apiClient.get(`/moderators/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching client by ID:', error);
      throw error;
    }
  },

  // Create new client
  createClient: async (clientData) => {
    try {
      const response = await apiClient.post('/moderators/', clientData);
      return response.data;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },

  // Update client
  updateClient: async (id, clientData) => {
    try {
      const response = await apiClient.put(`/moderators/${id}`, clientData);
      return response.data;
    } catch (error) {
      console.error('Error updating client:', error);
      throw error;
    }
  },

  // Delete client
  deleteClient: async (id) => {
    try {
      const response = await apiClient.delete(`/moderators/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting client:', error);
      throw error;
    }
  },

  // Set moderator password
  setPassword: async (id, password) => {
    try {
      const response = await apiClient.post(`/moderators/${id}/set-password`, { password });
      return response.data;
    } catch (error) {
      console.error('Error setting password:', error);
      throw error;
    }
  },
};

// Data transformation utility
export const transformClientData = (apiData) => {
  return apiData.map(item => {
    const rawPwd = item.password ?? item.client_password ?? '';
    const hasPassword =
      item.has_password === true ||
      item.password_set === true ||
      item.hasPassword === true ||
      (typeof rawPwd === 'string' && rawPwd.length > 0);
    return {
      id: item.id,
      name: item.name,
      email: item.email,
      apiKey: item.api_key,
      /** Plain password rarely returned by API; keep for UI if present */
      password: typeof rawPwd === 'string' ? rawPwd : '',
      hasPassword,
      isActive: item.is_active === 'true' || item.is_active === true,
      createdAt: item.created_at,
      updatedAt: item.updated_at
    };
  });
};

export default clientApi;
